registerComponent("product-blocks/product-generic-content", function (component) {

});
